// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zmSI","option":"styles_option__1dsQC","selected":"styles_selected__10ni3"};